export default __webpack_public_path__ + "static/media/percentage~kTThoWYP.85e6542f.svg";